import React, { Component } from 'react';
import { Link } from 'react-router-dom';

    class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            errors: []
        };
        this.handleLogin = this.handleLogin.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.hasError = this.hasError.bind(this);
        this.renderError = this.renderError.bind(this);
    }

    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleLogin(event) {
        event.preventDefault();

        const {history} = this.props;

        const user = {
            username: this.state.username,
            password: this.state.password
        };

        axios.post('/login', user)
                .then(response => {
                    if (response.data.success) {
                        window.localStorage.setItem('token', 'Bearer ' + response.data.success.token);
                        window.location.href = '/home';
                    } else {
                        this.setState({
                            errors: response.data.errors
                        });
                    }
                })
                .catch(error => {
                    this.setState({
                        errors: error.response.data.errors
                    });
                });
    }

    hasError() {
        var count = 0;
        $.each(this.state.errors, function () {
            count++;
        });
        return count;
    }

    renderError() {
        if (this.hasError()) {
            return (
                    <div className="alert alert-danger">
                        <ul className="reset-list">
                            {Object.keys(this.state.errors).map((key, i) =>
                                        <li key={i}>{this.state.errors[key]}</li>
                                )}
                        </ul>
                    </div>
                    );
        }
    }

    render() {
        return (
                <div className="wrapper">
                    <div id="content">
                        <form id="formlogin" method="POST" onSubmit={this.handleLogin}>
                            <main id="login">
                                <div className="position-absolute h-100 w-100 m-0 d-flex align-items-center justify-content-center">
                                    <div className="mx-auto" id="login_container">
                                        <div className="login_emitter">
                                            <div className="login_wave">
                                            </div>
                                            <div className="card p-5">
                                                {this.renderError()}
                                                <div className="card-body">
                                                    <figure className="mb-5 text-center">
                                                        <img src="/img/logo.svg" height="120" />
                                                    </figure>
                                                    <div className="form-group row">
                                                        <input onChange={this.handleFieldChange} id="username" type="text" className="form-control" name="username" placeholder="admin@kozo-japan.com" required autoFocus />
                                                    </div>
                                                    <div className="form-group row">
                                                        <input onChange={this.handleFieldChange} id="password" type="password" className="form-control" name="password" required />
                                                    </div>
                                                    <div className="form-group row pt-2 mb-0">
                                                        <button type="submit" className="btn btn-warning btn-lg btn-block">ログイン</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </form>
                    </div>
                </div>
            );
    }
}

export default Login